import { render, staticRenderFns } from "./IndexUsers.vue?vue&type=template&id=54302eb0"
import script from "./IndexUsers.vue?vue&type=script&lang=js"
export * from "./IndexUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports